// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"324":"f6af3fc1","362":"06a932ef","572":"e9f4d893","655":"a685280c","925":"aff61680"}[chunkId] + ".chunk.js";
};